module.exports = __webpack_public_path__ + "josefin.7270440b8ddb42ebfe9f.woff2";


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/fonts/josefin.woff2
// module id = ../../../../../angular/fonts/josefin.woff2
// module chunks = 2